import { z } from 'zod';
import type { IAPI } from '../../apiResponse';
import { createApiResponseSchema } from '../../apiResponse';
import { collectionSchema } from '../collection-schema';

const browseCollectionsRowSchema = z.object({
  type: z.string(),
  collections: z.array(collectionSchema),
});

export type IBrowseCollectionsRow = z.infer<typeof browseCollectionsRowSchema>;

const browseCollectionsDataSchema = z.object({
  featured: z.array(collectionSchema),
  rows: z.array(browseCollectionsRowSchema),
});

export type IBrowseCollectionsData = z.infer<typeof browseCollectionsDataSchema>;

export const browseCollectionsResponseSchema = createApiResponseSchema(
  browseCollectionsDataSchema,
) as z.ZodSchema<IAPI<IBrowseCollectionsData>>;

export type IBrowseCollectionsResponse = IAPI<IBrowseCollectionsData>;
